export default {
  contentblock: 'Content block',
  contentblocks: 'Content blocks',
  verbose_contentblock: 'a contentblock',
  general_info: 'General information',
  position: 'Position',
  text_align: 'Text alignment',
  height: 'Height',
  width: 'Width',
  min_height: 'Minimum height',
  max_width: 'Maximum width',
  bk_color: 'Background color',
  text_color: 'Text color',

  href: 'Link',
  targetblank: 'Target',
  youtube_id: 'Youtube video ID',
};
